import { AtomChannels, AtomTopics } from '@client/core/atoms/consts.js';
import { atom } from '@podium/store';
import type {
  MartailerPlacement,
  LayoutType
} from '@schibsted-nmp/advertising-shared';

type RetailMediaEventType = 'layout_change' | 'search_change' | 'init';

type RetailMediaAtom = {
  placements: Array<MartailerPlacement>;
  searchQuery?: string | undefined;
  categories?: string[] | undefined;
  layoutType?: LayoutType | undefined;
  eventType?: RetailMediaEventType;
};

export const $retailMediaAtom = atom<$retailMediaAtom.Value>(
  AtomChannels.Podlet,
  AtomTopics.Martailer,
  {
    placements: [],
    searchQuery: undefined,
    categories: undefined,
    layoutType: undefined,
    eventType: 'init'
  }
);

export namespace $retailMediaAtom {
  export type Value = RetailMediaAtom;
}
